import type {AsyncDataOptions} from '#app';

// locals
import FetchFactory from '../factory';
import type {PaginatedDataResult, Post, Profile, User} from "~/repository/types";
import ProfileModel from "~/repository/models/Profile";


class ProfileModule extends FetchFactory {
    private RESOURCE = '/users';

    /**
     * Return the posts paginated array
     * @param username
     * @param asyncDataOptions
     * @returns
     */
    async get(
        username: string,
        asyncDataOptions?: AsyncDataOptions<Profile>
    ) {
        return useAsyncData(
            () => {
                return this.call<Profile>(
                    'GET',
                    `${this.RESOURCE}/${username}`
                )
            },
            asyncDataOptions
        )
    }

    async edit(username: string, name: string, bio: string | undefined = undefined, location: string | undefined = undefined, website: string | undefined = undefined) {
        const {data} = await this.call<{ data: Profile }>('PUT', `/profile`, {
            username,
            name,
            bio,
            location,
            website
        })

        return ProfileModel.create<User>(data)
    }

    async updateAvatar(id: string) {
        const {data} = await this.call<{ data: Profile }>('POST', `/profile/image`, {
            media_id: id
        })

        return ProfileModel.create<User>(data)
    }

    async getPurchasedPosts() {
        return this.call<PaginatedDataResult<Post>>('GET', `/posts/my/bought`);
    }


    async getFollowers(
        username: string,
        page: number | undefined
    ) {
        const paginatedData = await this.call<PaginatedDataResult<Profile>>(
            'GET',
            `${this.RESOURCE}/${username}/followers`,
            {
                page
            }
        )

        return {
            ...paginatedData,
            data: paginatedData.data.map(ProfileModel.create)
        }
    }

    async getFollowings(
        username: string,
        page: number | undefined
    ) {
        const paginatedData = await this.call<PaginatedDataResult<Profile>>(
            'GET',
            `${this.RESOURCE}/${username}/followings`,
            {
                page
            }
        )

        return {
            ...paginatedData,
            data: paginatedData.data.map(ProfileModel.create)
        }
    }

    async follow(id: number) {
        const {data} = await this.call<any>('POST', `${this.RESOURCE}/${id}/follow`)
        return new ProfileModel(data)
    }

    async unfollow(id: number) {
        const {data} = await this.call<any>('POST', `${this.RESOURCE}/${id}/unfollow`)
        return new ProfileModel(data)
    }

}

export default ProfileModule;